import React, { useCallback, useEffect, useMemo, useState } from "react";
import CollegeProgramDataService from "../../../Services/CollegeProgramService";
import { toast } from "react-toastify";

export default function UpdateProgramDoc({
  fileInputRef,
  data,
  setData,
  label,
  imageURL,
  setImageURL,
}) {
  const [updating, setUpdating] = useState(false);

  const getProgramBrochure = useCallback(
    async (programId) => {
      try {
        setUpdating(true);
        const response =
          await CollegeProgramDataService.downloadProgramBrochure(programId);
        if (label === "brochure") {
          setImageURL(response?.data?.response?.brochureUrl);
        }
      } catch (error) {
        toast.error(error);
      }
      setUpdating(false);
    },
    [label, setImageURL]
  );

  const handleProgramDocInput = useCallback(
    async (event) => {
      setUpdating(true);

      const { files } = event.target;

      const file = files[0];

      if (file) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setData((p) => ({
            ...p,
            [label]: reader.result.split(",")[1],
            [`${label}Name`]: file.name,
            [`${label}type`]: file.type,
          }));
        };
        reader.readAsDataURL(file);
        setUpdating(false);
      }
    },
    [label, setData]
  );

  useEffect(() => {
    if (data.id) {
      getProgramBrochure(data.id);
    }
  }, [data.id, getProgramBrochure]);

  const editImageContent = useMemo(() => {
    switch (true) {
      case !!imageURL:
        return (
          <div className="d-flex justify-content-center mt-2 position-relative">
            {imageURL.includes(".pdf") ? (
              <div
                className="pdf-preview-container"
                style={{
                  width: "100%",
                  height: "180px",
                  border: "1px solid #dee2e6",
                  borderRadius: "4px",
                  overflow: "hidden",
                }}
              >
                <div
                  className="pdf-header"
                  style={{
                    background: "#f8f9fa",
                    padding: "8px 12px",
                    borderBottom: "1px solid #dee2e6",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div className="d-flex align-items-center">
                    <i className="bi bi-file-earmark-pdf text-danger me-2"></i>
                    <span className="text-muted small">Current Brochure</span>
                  </div>
                  <a
                    href={imageURL}
                    download="program-brochure.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-sm btn-outline-primary"
                    style={{ fontSize: "12px", padding: "2px 8px" }}
                  >
                    <i className="bi bi-download me-1"></i>
                    Download
                  </a>
                </div>
                <embed
                  src={imageURL}
                  type="application/pdf"
                  width="100%"
                  height="calc(100% - 40px)"
                  style={{ border: "none" }}
                  onError={(e) => {
                    e.target.style.display = "none";
                    e.target.nextSibling.style.display = "block";
                  }}
                />
                <div
                  className="pdf-error-fallback"
                  style={{
                    display: "none",
                    height: "calc(100% - 40px)",
                    background: "#f8f9fa",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "#6c757d",
                  }}
                >
                  <i
                    className="bi bi-file-earmark-pdf text-danger"
                    style={{ fontSize: "2rem", marginBottom: "8px" }}
                  ></i>
                  <p className="mb-1 small">PDF Preview not available</p>
                  <a
                    href={imageURL}
                    download="program-brochure.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-sm btn-outline-primary"
                    style={{ fontSize: "12px" }}
                  >
                    <i className="bi bi-download me-1"></i>
                    Download to view
                  </a>
                </div>
              </div>
            ) : (
              <img
                src={imageURL}
                alt="updated"
                className=""
                style={{ maxWidth: "100%", maxHeight: "180px" }}
              />
            )}
          </div>
        );
      case !!data[label]:
        return (
          <div className="d-flex mt-2 position-relative">
            {data[`${label}type`] === "application/pdf" ? (
              <div
                className="pdf-preview-container"
                style={{
                  width: "100%",
                  height: "180px",
                  border: "1px solid #dee2e6",
                  borderRadius: "4px",
                  overflow: "hidden",
                }}
              >
                <div
                  className="pdf-header"
                  style={{
                    background: "#f8f9fa",
                    padding: "8px 12px",
                    borderBottom: "1px solid #dee2e6",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div className="d-flex align-items-center">
                    <i className="bi bi-file-earmark-pdf text-danger me-2"></i>
                    <span className="text-muted small">
                      {data[`${label}Name`]}
                    </span>
                  </div>
                  <a
                    href={`data:${data[`${label}type`]};base64,${data[label]}`}
                    download={data[`${label}Name`]}
                    className="btn btn-sm btn-outline-primary"
                    style={{ fontSize: "12px", padding: "2px 8px" }}
                  >
                    <i className="bi bi-download me-1"></i>
                    Download
                  </a>
                </div>
                <embed
                  src={`data:${data[`${label}type`]};base64,${data[label]}`}
                  type="application/pdf"
                  width="100%"
                  height="calc(100% - 40px)"
                  style={{ border: "none" }}
                  onError={(e) => {
                    e.target.style.display = "none";
                    e.target.nextSibling.style.display = "block";
                  }}
                />
                <div
                  className="pdf-error-fallback"
                  style={{
                    display: "none",
                    height: "calc(100% - 40px)",
                    background: "#f8f9fa",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "#6c757d",
                  }}
                >
                  <i
                    className="bi bi-file-earmark-pdf text-danger"
                    style={{ fontSize: "2rem", marginBottom: "8px" }}
                  ></i>
                  <p className="mb-1 small">PDF Preview not available</p>
                  <a
                    href={`data:${data[`${label}type`]};base64,${data[label]}`}
                    download={data[`${label}Name`]}
                    className="btn btn-sm btn-outline-primary"
                    style={{ fontSize: "12px" }}
                  >
                    <i className="bi bi-download me-1"></i>
                    Download to view
                  </a>
                </div>
              </div>
            ) : (
              <img
                src={`data:${data[`${label}type`]};base64,${data[label]}`}
                alt="Uploaded"
                className=""
                style={{ maxWidth: "100%", maxHeight: "180px" }}
              />
            )}
          </div>
        );
      default:
        return (
          <>
            <div className="text1-4 text-dark1 d-flex align-items-center justify-content-center mt-1">
              <label
                htmlFor={`importInput_${label}`}
                style={{ cursor: "pointer" }}
              >
                <div className="d-flex gap-1 align-items-center">
                  <i className="bi bi-cloud-plus text-dark1 text2-5 d-flex align-items-center justify-content-center me-2"></i>

                  <span>Upload Document</span>
                </div>
              </label>

              <input
                id={`importInput_${label}`}
                type="file"
                className="d-none"
                ref={fileInputRef}
                accept="image/jpeg,image/jpg,image/png,application/pdf"
                onChange={handleProgramDocInput}
              />
            </div>
          </>
        );
    }
  }, [data, fileInputRef, handleProgramDocInput, imageURL, label]);

  if (updating) {
    return (
      <div
        style={{
          height: "100px",
        }}
        className="d-flex justify-content-center align-items-center w-100"
      >
        <span className="spinner-border "></span>
      </div>
    );
  } else {
    return editImageContent;
  }
}
